import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Redux
import { connect } from 'react-redux';
import { change as dispatchFormChange } from 'redux-form';

// Compose
import { graphql, gql, compose } from 'react-apollo';
// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';
// External Component
import { DateUtils } from 'react-day-picker';
// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import {
	FormGroup,
	ControlLabel,
	Form
} from 'react-bootstrap';
// Loader
import Loader from '../Loader';
import CommonFormComponent from '../CommonField/CommonFormComponent';
import { getListBlockedDates } from '../../actions/Listing/getListBlockedDates';
import { getListingDataStep3 } from '../../actions/getListingDataStep3';
// Locale
import messages from '../../locale/messages';
import validate from './validate';
import { normalizePrice } from '../EditProfileForm/normalizePhone';
import showToaster from '../../helpers/toasterMessages/showToaster';
import s from '!isomorphic-style-loader!css-loader!./DayDragCalendar.css';
import c from './SaveCalendar.css';
import cs from '../commonStyle.css';

function toDayKey(value) {
	if (!value) {
		return null;
	}
	// Match DayDragCalendar display: local calendar day.
	return moment(value).format('YYYY-MM-DD');
}

function buildDateRange(start, end) {
	const dateRange = [];
	if (!start) {
		return dateRange;
	}

	const rangeStart = moment(start).startOf('day');
	const rangeEnd = end ? moment(end).startOf('day') : rangeStart.clone();

	if (rangeEnd.isBefore(rangeStart)) {
		return dateRange;
	}

	const cursor = rangeStart.clone();
	while (cursor.isSameOrBefore(rangeEnd, 'day')) {
		dateRange.push(cursor.toDate());
		cursor.add(1, 'day');
	}
	return dateRange;
}

/**
 * Autofill only when every selected day has the same special price.
 * Mixed or missing specials → blank (user can still type a new price).
 */
export function specialPriceForSelection(start, end, availableDatesPrices) {
	if (!start || !availableDatesPrices || availableDatesPrices.length === 0) {
		return '';
	}
	const days = buildDateRange(start, end);
	if (days.length === 0) {
		return '';
	}

	const priceByDay = {};
	availableDatesPrices.forEach((item) => {
		const itemDate = item.date || item.blockedDates;
		const key = toDayKey(itemDate);
		const amount = Number(item.isSpecialPrice);
		if (key && item.isSpecialPrice != null && !isNaN(amount) && amount > 0) {
			priceByDay[key] = amount;
		}
	});

	const prices = days.map((day) => priceByDay[toDayKey(day)]);
	if (prices.some((price) => price == null)) {
		return '';
	}

	const unique = Array.from(new Set(prices.map((price) => String(price))));
	return unique.length === 1 ? unique[0] : '';
}

class AvailableDates extends Component {

	constructor(props) {
		super(props);
		this.state = {
			dateRange: [],
			isLoading: false,
			isDisabled: false
		};
		this.submitForm = this.submitForm.bind(this);
		this.syncSpecialPriceField = this.syncSpecialPriceField.bind(this);
	}

	componentDidMount() {
		const { formErrors, start, end, isStartDate, isEndDate, availableDatesPrices } = this.props;
		this.setState({ isDisabled: formErrors?.hasOwnProperty('syncErrors') ? true : false });
		const nextStart = start || isStartDate;
		const nextEnd = end || isEndDate;
		this.setState({ dateRange: buildDateRange(nextStart, nextEnd) });
		this.syncSpecialPriceField(nextStart, nextEnd, availableDatesPrices);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { start, end, formErrors, isStartDate, isEndDate, availableDatesPrices } = nextProps;
		const prevStart = this.props.start || this.props.isStartDate;
		const prevEnd = this.props.end || this.props.isEndDate;
		const nextStart = start || isStartDate;
		const nextEnd = end || isEndDate;

		this.setState({ isDisabled: formErrors?.hasOwnProperty('syncErrors') ? true : false });
		this.setState({ dateRange: buildDateRange(nextStart, nextEnd) });

		const selectionChanged =
			toDayKey(prevStart) !== toDayKey(nextStart) ||
			toDayKey(prevEnd) !== toDayKey(nextEnd);
		const pricesChanged = this.props.availableDatesPrices !== availableDatesPrices;

		if (selectionChanged || pricesChanged) {
			this.syncSpecialPriceField(nextStart, nextEnd, availableDatesPrices);
		}
	}

	syncSpecialPriceField(start, end, availableDatesPrices) {
		// redux-form injects bound change(field, value) — do NOT pass the form name.
		const { change } = this.props;
		const value = start
			? specialPriceForSelection(start, end, availableDatesPrices)
			: '';
		change('isSpecialPrice', value);
	}


	async submitForm() {
		const { listId, resetCalendar, dispatchFormChange, change } = this.props;
		const { isSpecialPrice, start, end, getListBlockedDates, getListingDataStep3 } = this.props;
		const { minDay, maxDay, houseRules, checkInEnd, checkInStart } = this.props;
		const { cancellationPolicy, maxDaysNotice, bookingNoticeTime } = this.props;
		const { basePrice, delivery, currency, isStartDate, isEndDate, monthlyDiscount, weeklyDiscount, securityDeposit } = this.props;
		const { removeBlockedDates, updateBlockedDates, setStateLoading } = this.props;

		let minDayValues, maxDayValues, checkInEndValue, checkInStartValue, isCancel,
			isMaxDays, isBooking, updatedAvailableDatesDays, dateRangeNew = [];

		minDayValues = minDay != '' ? minDay : 0;
		maxDayValues = maxDay != '' ? maxDay : 0;
		checkInEndValue = checkInEnd != '' ? checkInEnd : 'flexible';
		checkInStartValue = checkInStart != '' ? checkInStart : 'flexible';
		isCancel = cancellationPolicy ? cancellationPolicy : '1';
		isMaxDays = maxDaysNotice ? maxDaysNotice : 'unavailable';
		isBooking = bookingNoticeTime ? bookingNoticeTime : 58;
		updatedAvailableDatesDays = this.state.dateRange.slice();
		setStateLoading({ isBlocking: true })

		dateRangeNew = buildDateRange(isStartDate || start, isEndDate || end);

		const trimmedSpecial =
			isSpecialPrice === undefined || isSpecialPrice === null
				? ''
				: String(isSpecialPrice).trim();

		if (trimmedSpecial !== '' && (isNaN(trimmedSpecial) || (parseFloat(trimmedSpecial, 10) < 0.1))) {
			showToaster({ messageId: 'invalidSpecialPrice', toasterType: 'error' })
			setStateLoading({ isBlocking: false })
			return;
		}

		if (dateRangeNew?.length > 0) {

			dateRangeNew.forEach((item) => {
				let selectedIndex = updatedAvailableDatesDays.findIndex(selectedDay =>
					DateUtils.isSameDay(selectedDay, item)
				);

				if (selectedIndex < 0) {
					updatedAvailableDatesDays.push(item);
				}
			});


			if (trimmedSpecial !== '' && parseFloat(trimmedSpecial, 10) > 0) {

				const { data } = await updateBlockedDates({
					variables: {
						listId,
						blockedDates: updatedAvailableDatesDays,
						calendarStatus: 'available',
						isSpecialPrice: parseFloat(trimmedSpecial, 10)
					}
				});

				if (data?.UpdateBlockedDates?.status == '400') {
					showToaster({ messageId: 'updateBlockedDates', toasterType: 'error' })
				}

			} else {
				// Clear special price for the range → days fall back to base price.
				const { data } = await removeBlockedDates({
					variables: {
						listId,
						blockedDates: updatedAvailableDatesDays,
					}
				});
				if (data?.removeBlockedDates?.status == '200') {

				} else if (data?.removeBlockedDates?.status == '400') {
					showToaster({ messageId: 'removeBlockedDates', toasterType: 'error' })
				} else {
					setStateLoading({ isBlocking: false })
				}
			}
			await dispatchFormChange('ListPlaceStep3', 'blockedDates', updatedAvailableDatesDays);
			await getListingDataStep3(listId);
			await getListBlockedDates(
				listId,
				minDayValues,
				maxDayValues,
				checkInEndValue,
				checkInStartValue,
				houseRules,
				isCancel,
				isMaxDays,
				isBooking,
				basePrice,
				delivery,
				currency,
				monthlyDiscount,
				weeklyDiscount,
				securityDeposit
			);
			await getListingDataStep3(listId);
			await change('isSpecialPrice', '');
			await resetCalendar();
			window.scroll({ top: 0 });
			setStateLoading({ isBlocking: false })
		}
	}


	render() {
		const { error, handleSubmit, submitting, start, end, isStartDate, isBlocking, isSaving } = this.props;
		const { formatMessage } = this.props.intl;
		const { isDisabled } = this.state;

		return (
			<div>
				{
					(start || isStartDate) && <span>
						<Form onSubmit={handleSubmit(this.submitForm)}>
							{error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
							<FormGroup className={cx(s.formGroup, cs.spaceBottom4)}>
								<ControlLabel className={s.landingLabel}>
									<FormattedMessage {...messages.sessionPrice} />
								</ControlLabel>
								<Field
									name="isSpecialPrice"
									type="text"
									component={CommonFormComponent}
									label={formatMessage(messages.basePriceLabel)}
									inputClass={cx(s.formControlInput, s.jumboInput, c.inputHeight)}
									normalize={normalizePrice}
								/>
							</FormGroup>
							<FormGroup className={cx(c.formGroup, c.buttonLeft, 'arButtonLoader', 'buttonLeftRTL')}>
								<Loader
									type={"button"}
									buttonType={"button"}
									show={isBlocking}
									className={cx(c.btnPrimary, c.btnlarge)}
									disabled={submitting || isSaving || isDisabled}
									label={formatMessage(messages.save)}
									containerClass={c.loaderContainer}
									handleClick={this.submitForm}
								/>
							</FormGroup>
						</Form>
					</span>
				}
			</div>
		);
	}
}

AvailableDates = reduxForm({
	form: 'CalendarPrice', // a unique name for this form
	validate,
	enableReinitialize: true,
})(AvailableDates);

const selector = formValueSelector('CalendarPrice');

const mapState = (state) => ({
	isSpecialPrice: selector(state, 'isSpecialPrice'),
	formErrors: state.form.CalendarPrice,
});

const mapDispatch = {
	dispatchFormChange,
	getListBlockedDates,
	getListingDataStep3
};

export default compose(
	injectIntl,
	withStyles(s, c, cs),
	connect(mapState, mapDispatch),
	graphql(gql`
    mutation (
      $listId: Int!, 
      $blockedDates: [String],
      $calendarStatus: String,
      $isSpecialPrice: Float
    ) {
          UpdateBlockedDates (
            listId: $listId, 
            blockedDates: $blockedDates,
            calendarStatus: $calendarStatus,
            isSpecialPrice: $isSpecialPrice
        ) {
          status
        }
        }
  `, {
		name: 'updateBlockedDates'
	}),
	graphql(gql`
      mutation removeBlockedDates(
      $listId: Int!,
      $blockedDates: [String],
      ){
        removeBlockedDates(
          listId: $listId, 
          blockedDates: $blockedDates,
          ) {
              status
              errorMessage
          }
      }
  `, {
		name: 'removeBlockedDates'
	}),
)(AvailableDates);
